export { default as RecentKeywords } from './RecentKeywords';
